import React from "react";
import classes from "./styles/style.module.css";
import CustomModal from "../../assets/components/ModalComonent";
import CustomButton from "../../assets/components/CustomButton";
import HintImg from "../../assets/images/joftPooch/HintImg.png";
import LoadingDialog from "../../assets/containers/loadingDialog";

export default function StartExamAlert({
  show,
  startExam,
  loading,
  handleClose,
  form,
}) {
  const modalContent = (
    <>
      <div className="w-100 text-center">
        <img src={HintImg} alt="awardIcon" className={classes.alertBanner} />
        <p className={classes.Dialogtitle}>شروع آزمون</p>
        <div className={classes.dialogContent}>
          <p className="text-center">
            فرم مورد نظر یک آزمون است 
            <br />
            {form?.examSettings?.durationEnabled && (
              <span>مدت زمان آزمون: {form.examSettings.durationMinutes} دقیقه</span>
            )}
          </p>
        </div>
        <div className="w-100 mt-4">
          {loading ? (
            <LoadingDialog
              className={"d-flex justify-content-center"}
              size={20}
            />
          ) : (
            <CustomButton
              clickHandler={startExam}
              color={"primary"}
              shadow
              text={"شروع آزمون"}
            />
          )}
        </div>
      </div>
    </>
  );
  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={modalContent}
    />
  );
}
